import React from "react";
import { Input } from "../../../../components/common/Input";

type Props = {
    name: string;
    phone: string;
    onChange: (field: "name" | "phone" | "about", value: string) => void;
};

export const ProfileFields: React.FC<Props> = ({ name, phone, onChange }) => (
    <>
        <Input label="Имя" name="name" value={name} onChange={(v) => onChange("name", v)} type="text" />
        <Input label="Телефон" name="phone" value={phone} onChange={(v) => onChange("phone", v)} type="text" />
    </>
);
